// src/pages/admin/components/AssignmentManagement/AssignmentList.js
import React, { memo, useCallback } from 'react';

const AssignmentList = ({
  assignments,
  selectedAssignment,
  onSelectAssignment,
  onCreateNew,
  onReorderAssignment
}) => {
  const moveAssignmentUp = useCallback((index) => {
    if (index === 0) return;
    const assignment = assignments[index];
    const prevAssignment = assignments[index - 1];
    let newOrder;
    if (index > 1) {
      const prevPrevAssignment = assignments[index - 2];
      newOrder = prevPrevAssignment.order + (prevAssignment.order - prevPrevAssignment.order) / 2;
    } else {
      newOrder = prevAssignment.order - 10;
    }
    onReorderAssignment(assignment.id, newOrder);
  }, [assignments, onReorderAssignment]);

  const moveAssignmentDown = useCallback((index) => {
    if (index === assignments.length - 1) return;
    const assignment = assignments[index];
    const nextAssignment = assignments[index + 1];
    let newOrder;
    if (index < assignments.length - 2) {
      const nextNextAssignment = assignments[index + 2];
      newOrder = nextAssignment.order + (nextNextAssignment.order - nextAssignment.order) / 2;
    } else {
      newOrder = nextAssignment.order + 10;
    }
    onReorderAssignment(assignment.id, newOrder);
  }, [assignments, onReorderAssignment]);

  const handleSelectAssignment = useCallback((assignment) => {
    onSelectAssignment(assignment);
  }, [onSelectAssignment]);

  return (
    <div className="assignments-list">
      <div className="list-header">
        <h3>Assignments ({assignments.length})</h3>
        <button className="btn-primary create-button" onClick={onCreateNew}>
          <span className="icon">+</span> Create New Assignment
        </button>
      </div>

      {assignments.length > 0 ? (
        <ul className="assignment-items">
          {assignments.map((assignment, index) => (
            <li
              key={assignment.id}
              className={`assignment-item ${selectedAssignment?.id === assignment.id ? 'selected' : ''}`}
              onClick={() => handleSelectAssignment(assignment)}
            >
              <div className="assignment-drag-indicator">
                <button
                  className="reorder-btn up"
                  onClick={(e) => { e.stopPropagation(); moveAssignmentUp(index); }}
                  disabled={index === 0}
                  title="Move up"
                >
                  ▲
                </button>
                <button
                  className="reorder-btn down"
                  onClick={(e) => { e.stopPropagation(); moveAssignmentDown(index); }}
                  disabled={index === assignments.length - 1}
                  title="Move down"
                >
                  ▼
                </button>
              </div>
              <div className="assignment-content">
                <div className="assignment-name-wrapper">
                  <div className="assignment-name">{assignment.title}</div>
                </div>
                <div className="assignment-dates">
                  {assignment.startDate && (
                    <span className="start-date">
                      <span className="date-label">Start:</span> {assignment.startDate.toLocaleDateString()}
                    </span>
                  )}
                  {assignment.endDate && (
                    <span className="end-date">
                      <span className="date-label">Due:</span> {assignment.endDate.toLocaleDateString()}
                    </span>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="empty-list">
          <p>No assignments yet. Use the button above to create one.</p>
        </div>
      )}
    </div>
  );
};

export default memo(AssignmentList);